import {Component, inject, OnInit} from '@angular/core';
import {
  ControlContainer,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormGroup,
} from '@angular/forms';
import {EmInputModule, EmMoreInfoModule} from '@em/shared/ui';
import {TranslateModule} from '@ngx-translate/core';

@Component({
  selector: 'em-product-performance-filter',
  templateUrl: './product-performance-filter.component.html',
  styleUrls: ['./product-performance-filter.component.scss'],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    EmInputModule,
    EmMoreInfoModule,
  ],
})
export class EmProductPerformanceFilterComponent implements OnInit {
  private readonly _controlContainer = inject(ControlContainer);
  formGroup: UntypedFormGroup | null | undefined;

  ngOnInit(): void {
    this.formGroup = this._controlContainer.control as UntypedFormGroup;
  }
}
